import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchNews } from "ActionsNews";
import ContentIcon, { HEADING_NEWS } from "ContentIcon";
import NoContent, { NO_NEWS } from "NoContent";
import { screenHeightLeftFromTop } from "Constants";
import AddNews from "./add-news";
import NewsList from "./news-list";
import InfoTutorial from "InfoTutorial";
import Loader from "Loader";

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      pageNumber: 0,
      executed: false,
      loading: true,
      desc: "Preparing News",
    };
    this.paginationCallback = this.paginationCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.contentAvailable) {
      var news = this.props.fetchNews(this.props.session, "", 0, (callback) => {
        this.setState({ loading: false });
      });
      this.setState({ news: news });
    } else {
      this.props.history.push("/dashboard/content");
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (nextProps.contentAvailable && !this.state.executed) {
        var news = this.props.fetchNews(
          this.props.session,
          "",
          0,
          (callback) => {
            this.setState({ loading: false });
          }
        );
        this.setState({ news: news, executed: true });
      } else {
        this.props.history.push("/dashboard/content");
      }
    }
  };

  handleSearch = (event) => {
    var search = event.target.value;
    this.setState({ news: this.props.news, search: search, pageNumber: 0 });

    this.props.fetchNews(this.props.session, search, 0, (callback) => {
      this.setState({ loading: false });
    });
  };

  paginationCallback(pageNumber) {
    this.setState({ ...this.state, pageNumber });
    this.props.fetchNews(this.props.session, "", pageNumber, (callback) => {});
  }

  render() {
    var newsAvailable = this.props.news.data && this.props.news.data.length > 0;
    let { deviceSize } = this.props;

    return (
      <div classsName="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <ContentIcon heading={HEADING_NEWS} />
          </div>

          <ul className="header-buttons">
            <li>
              <input
                className="form-control mapsearch search-tabwidth"
                placeholder="Search"
                type="text"
                value={this.state.search}
                onChange={this.handleSearch}
              />
            </li>
            <li>
              <AddNews history={this.props.history} />
            </li>
            <li>
              <InfoTutorial video="news.mp4" />
            </li>
          </ul>
        </div>
        <div className="clearfix"></div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : newsAvailable ? (
            <NewsList
              paginationCallback={this.paginationCallback}
              search={this.state.search}
            />
          ) : (
            <NoContent contentType={NO_NEWS} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;
  return {
    news: state.news,
    session: state.session,
    contentAvailable,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, { fetchNews })(News);
